<template>
  <mdb-dropdown>
    <mdb-dropdown-toggle slot="toggle" class="dt-btn-primary"
      >REGION</mdb-dropdown-toggle
    >
    <mdb-dropdown-menu>
      <mdb-dropdown-item
        v-for="(region, index) in regions"
        :key="index"
        @click="filter($event)"
        >{{ region }}</mdb-dropdown-item
      >
    </mdb-dropdown-menu>
  </mdb-dropdown>
</template>
<script>
import {
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";
import { applyFilter } from "../common/utilities/mapController";
import { getRegions } from "../common/dataSourceIntegrationService";
export default {
  name: "ZoomByRegion",
  data() {
    return { mapFilters: this.$store.getters.mapFilters, regions: [] };
  },

  created() {
    getRegions().forEach(element => {
      this.regions.push(element.name);
    });
    this.regions.sort();
  },
  methods: {
    filter(event) {
      this.mapFilters["regions"] = [event.target.text];
      applyFilter(this.mapFilters);
      this.$emit("changed");
    }
  },
  components: {
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle
  }
};
</script>
